// src/constants/data.js

export const TRANSLATIONS = {
  "zh-CN": {
    app_name: "Zeno",
    profile: "个人中心",
    login_title: "欢迎回来",
    login_desc: "登录以同步您的专注数据",
    phone_placeholder: "手机号码",
    code_placeholder: "验证码",
    get_code: "获取",
    login_btn: "登 录",
    skip_login: "暂不登录",
    member_title: "开通会员",
    unlock_title: "解锁完整体验",
    unlock_desc: "投资自己，从每一次专注开始",
    plan_month: "月度会员",
    plan_year: "年度会员",
    plan_lifetime: "终身会员",
    recommend: "推荐",
    save_pct: "立省 30%",
    save_lifetime: "永久拥有",
    lifetime_price: "¥198",
    privilege: "会员权益",
    privileges: [
      { t: "全套高级主题", d: "五行·东方·西学 16 款设计，随心切换" },
      { t: "高级提示音效", d: "水晶 / 磬音 / 古琴" },
      { t: "数据云同步", d: "多设备实时备份" },
    ],
    pay_btn: "立即开通",
    pay_agreement: "支付即代表同意《用户协议》与《隐私政策》",
    member_active: "您已是 Pro 会员",
    member_active_desc: "已解锁全部高级权益，尽情专注吧",
    user_guest: "未登录用户",
    user_login_tip: "点击登录同步数据",
    user_vip: "Zeno Pro",
    user_title: "专注者",
    user_level: "Level 5 Master",
    stats_title: "学习动态",
    stats_duration: "专注时长",
    stats_streak: "连续打卡",
    stats_tasks: "完成任务",
    banner_title: "Zeno Pro",
    banner_desc: "解锁全部高级功能与云同步",
    banner_desc_vip: "尊享所有高级权益",
    banner_active: "已激活",
    sec_personal: "个性化",
    sec_general: "通用",
    theme_title: "界面主题",
    sound_title: "提示音效",
    lang_title: "语言 / Language",
    haptic_title: "触感反馈",
    sync_title: "数据同步",
    settings_neuro: "心流设置",
    mode_section: "专注模式",
    mode_hint: "按任务类型选择节奏，而不是无差别打断",
    evidence_strong: "证据较强",
    evidence_counter: "建议不打断",
    interval_label: "随机间隔 (分钟)",
    rest_replay_label: "闭眼重放休息",
    rest_none_label: "全程不打断",
    rest_overlay_title: "闭眼休息",
    rest_overlay_sub: "大脑正在重放刚才的内容…",
    pro_alert_note: "随机响铃为 Pro 功能",
    neuro_switch: "心流提示音",
    neuro_desc: "触发变比率强化，提升专注力",
    neuro_range: "随机间隔范围 (分钟)",
    neuro_tip: "* 提示音响起时，请立即闭眼休息10秒。",
    profile_title: "任务模式",
    profile_memorize: "记忆背诵",
    profile_memorize_d: "3-5分钟随机微休息，利用神经重放强化记忆",
    profile_skill: "技能练习",
    profile_skill_d: "4-6分钟随机微休息，巩固动作序列",
    profile_deep: "深度工作",
    profile_deep_d: "4-6分钟低频微休息 + 90/20 大循环，可随时关闭",
    protocol_title: "90/20 循环",
    protocol_desc: "专注结束后自动进入长休息，循环往复",
    protocol_focus_min: "专注(分)",
    protocol_rest_min: "休息(分)",
    protocol_focus_label: "专注",
    protocol_rest_label: "休息中",
    cycle_label: "第",
    cycle_unit: "轮",
    protocol_rest_start: "专注完成！进入长休息",
    protocol_focus_start: "休息结束，开始新一轮专注",
    micro_rest_skip: "点按跳过",
    done_btn: "完成配置",
    close_btn: "关闭",
    start_btn: "开始",
    rest_btn_short: "休息 5 分钟",
    rest_btn_long: "休息 20 分钟",
    continue_btn: "继续",
    congrats_title: "很棒！完成专注",
    session_done_prefix: "已专注",
    session_done_unit: "分钟",
    session_again: "再来一轮",
    session_rest: "休息 5 分钟",
    session_share: "分享成绩单",
    session_back: "返回",
    week_trend: "心流热力图",
    flow_time: "心流时间",
    flow_heatmap_hint: "颜色越深，当日心流时间越长",
    recent_record: "最近记录",
    today_record: "今日记录",
    day_record: "当日记录",
    total_count: "完成",
    count_unit: "项",
    no_record: "该日暂无专注记录",
    share: "分享",
    share_card_title: "我的专注成绩单",
    share_card_slogan: "专注当下，心流不止",
    share_total_focus: "累计专注",
    share_streak: "连续打卡",
    share_sessions: "专注次数",
    share_today_flow: "今日心流",
    share_unit_hours: "小时",
    share_unit_days: "天",
    share_unit_times: "次",
    share_save_img: "保存图片",
    share_do_share: "分享",
    share_saved_toast: "图片已保存",
    share_close: "关闭",
    share_card_today_title: "今日心流",
    share_card_week_title: "本周累计",
    share_card_total_title: "累计总览",
    share_week_focus: "本周专注",
    share_today_sessions: "今日完成",
    share_main_tag: "主要专注",
    share_active_days: "活跃天数",
    share_daily_avg: "日均",
    share_weekdays: ["一", "二", "三", "四", "五", "六", "日"],
    sync_toast: "数据同步成功",
    neuro_toast_title: "闭眼休息 10 秒",
    neuro_toast_desc: "大脑正在重放知识...",
    vip_success_title: "欢迎加入 Zeno Pro",
    vip_success_desc: "您已解锁所有高级权益",
    vip_success_btn: "开始专注之旅",
    sync_last_time: "上次同步",
    sync_cloud_data: "云端数据",
    sync_auto: "自动同步",
    sync_now: "立即同步",
    sync_records: "条记录",
    handoff_title: "其他设备上有专注正在进行",
    handoff_continue: "在此继续",
    handoff_remaining: "剩余",
    handoff_adopted: "已接力，继续专注",
    handoff_surrendered: "已在其他设备接力",
    handoff_dev_desktop: "桌面端",
    handoff_dev_mobile: "手机端",
    handoff_dev_web: "网页端",
    // 支付流程
    pay_method_title: "选择支付方式",
    pay_wechat: "微信支付",
    pay_alipay: "支付宝",
    pay_scan_title: "扫码支付",
    pay_scan_wechat: "请使用微信扫一扫完成支付",
    pay_scan_alipay: "请使用支付宝扫一扫完成支付",
    pay_failed: "支付失败",
    pay_unpaid: "订单未支付",
    pay_processing: "正在处理…",
    pay_loading_plans: "加载套餐中…",
    pay_wechat_auth_fail: "无法发起微信授权",
    pay_success_toast: "支付成功",
    pay_load_fail: "套餐加载失败，请重试",
    pay_retry: "重试",
    // 云同步
    sync_backup_desc: "实时备份数据至云端",
    sync_syncing: "同步中…",
    sync_never: "从未同步",
    sync_fail_toast: "同步失败，请重试",
    // 登录
    login_input_phone: "请输入手机号",
    login_input_code: "请输入验证码",
    login_invalid_phone: "手机号格式不正确",
    login_code_sent: "验证码已发送",
    login_send_fail: "发送失败，请重试",
    login_fail: "登录失败",
    tags: [
      "专注",
      "休息",
      "深度工作",
      "阅读",
      "写作",
      "学习",
      "会议",
      "运动",
      "小憩",
    ],
  },
  en: {
    app_name: "Zeno",
    profile: "Profile",
    login_title: "Welcome Back",
    login_desc: "Login to sync your focus data",
    phone_placeholder: "Phone Number",
    code_placeholder: "Code",
    get_code: "Get",
    login_btn: "Log In",
    skip_login: "Skip",
    member_title: "Go Pro",
    unlock_title: "Unlock Potential",
    unlock_desc: "Invest in yourself",
    plan_month: "Monthly",
    plan_year: "Yearly",
    plan_lifetime: "Lifetime",
    recommend: "BEST",
    save_pct: "Save 30%",
    save_lifetime: "One-time",
    lifetime_price: "$29.99",
    privilege: "Pro Benefits",
    privileges: [
      { t: "All Premium Themes", d: "16 designs, switch freely" },
      { t: "Premium Chimes", d: "Crystal / Gong / Koto" },
      { t: "Cloud Sync", d: "Real-time backup" },
    ],
    pay_btn: "Subscribe",
    pay_agreement: "Agree to Terms & Privacy",
    member_active: "You're a Pro member",
    member_active_desc: "All premium benefits unlocked",
    user_guest: "Guest",
    user_login_tip: "Tap to login",
    user_vip: "Zeno Pro",
    user_title: "Focuser",
    user_level: "Level 5 Master",
    stats_title: "Stats",
    stats_duration: "Hours",
    stats_streak: "Streak",
    stats_tasks: "Tasks",
    banner_title: "Zeno Pro",
    banner_desc: "Unlock all features",
    banner_desc_vip: "Premium Active",
    banner_active: "Active",
    sec_personal: "Personalization",
    sec_general: "General",
    theme_title: "Theme",
    sound_title: "Sound",
    lang_title: "Language",
    haptic_title: "Haptics",
    sync_title: "Cloud Sync",
    settings_neuro: "Flow Settings",
    mode_section: "Focus Mode",
    mode_hint: "Match the rhythm to your task, not a blind interruption",
    evidence_strong: "Well-supported",
    evidence_counter: "Better uninterrupted",
    interval_label: "Interval (min)",
    rest_replay_label: "Eyes-closed replay rest",
    rest_none_label: "No interruption",
    rest_overlay_title: "Close Your Eyes",
    rest_overlay_sub: "Your brain is replaying what you just learned…",
    pro_alert_note: "Random alert is a Pro feature",
    neuro_switch: "Flow Alert",
    neuro_desc: "Variable ratio reinforcement",
    neuro_range: "Interval Range (min)",
    neuro_tip: "* Close eyes for 10s when alert sounds.",
    profile_title: "Task Mode",
    profile_memorize: "Memorize",
    profile_memorize_d: "Random 3-5 min micro-rests for neural replay",
    profile_skill: "Skill Practice",
    profile_skill_d: "Random 4-6 min micro-rests for motor sequences",
    profile_deep: "Deep Work",
    profile_deep_d: "Low-freq 4-6 min micro-rests + 90/20 cycle, off anytime",
    protocol_title: "90/20 Cycle",
    protocol_desc: "Auto long-rest after each focus block",
    protocol_focus_min: "Focus (min)",
    protocol_rest_min: "Rest (min)",
    protocol_focus_label: "Focus",
    protocol_rest_label: "Resting",
    cycle_label: "Round",
    cycle_unit: "",
    protocol_rest_start: "Focus done! Time for a long rest",
    protocol_focus_start: "Rest over. New focus round",
    micro_rest_skip: "Tap to skip",
    done_btn: "Done",
    close_btn: "Close",
    start_btn: "Start",
    rest_btn_short: "Rest 5 min",
    rest_btn_long: "Rest 20 min",
    continue_btn: "Continue",
    congrats_title: "Great Job!",
    session_done_prefix: "Focused for",
    session_done_unit: "min",
    session_again: "Go Again",
    session_rest: "Rest 5 min",
    session_share: "Share Card",
    session_back: "Back",
    week_trend: "Flow Heatmap",
    flow_time: "Flow Time",
    flow_heatmap_hint: "Darker = more flow time that day",
    recent_record: "Recent",
    today_record: "Today",
    day_record: "History",
    total_count: "Done",
    count_unit: "tasks",
    no_record: "No records",
    share: "Share",
    share_card_title: "My Focus Report",
    share_card_slogan: "Stay present, stay in flow",
    share_total_focus: "Total Focus",
    share_streak: "Streak",
    share_sessions: "Sessions",
    share_today_flow: "Today's Flow",
    share_unit_hours: "h",
    share_unit_days: "d",
    share_unit_times: "x",
    share_save_img: "Save Image",
    share_do_share: "Share",
    share_saved_toast: "Image saved",
    share_close: "Close",
    share_card_today_title: "Today's Flow",
    share_card_week_title: "This Week",
    share_card_total_title: "All-Time",
    share_week_focus: "This Week",
    share_today_sessions: "Sessions",
    share_main_tag: "Top Focus",
    share_active_days: "Active Days",
    share_daily_avg: "Daily Avg",
    share_weekdays: ["M", "T", "W", "T", "F", "S", "S"],
    sync_toast: "Synced successfully",
    neuro_toast_title: "Rest Eyes 10s",
    neuro_toast_desc: "Neuro Replay in progress...",
    vip_success_title: "Welcome to Pro",
    vip_success_desc: "All premium features unlocked",
    vip_success_btn: "Start Focusing",
    sync_last_time: "Last Synced",
    sync_cloud_data: "Cloud Data",
    sync_auto: "Auto Sync",
    sync_now: "Sync Now",
    sync_records: "records",
    handoff_title: "A focus session is running on another device",
    handoff_continue: "Continue here",
    handoff_remaining: "Remaining",
    handoff_adopted: "Handed off — keep focusing",
    handoff_surrendered: "Handed off to another device",
    handoff_dev_desktop: "Desktop",
    handoff_dev_mobile: "Mobile",
    handoff_dev_web: "Web",
    // Payment
    pay_method_title: "Payment Method",
    pay_wechat: "WeChat Pay",
    pay_alipay: "Alipay",
    pay_scan_title: "Scan to Pay",
    pay_scan_wechat: "Scan with WeChat to complete payment",
    pay_scan_alipay: "Scan with Alipay to complete payment",
    pay_failed: "Payment failed",
    pay_unpaid: "Order unpaid",
    pay_processing: "Processing…",
    pay_loading_plans: "Loading plans…",
    pay_wechat_auth_fail: "Cannot start WeChat authorization",
    pay_success_toast: "Payment successful",
    pay_load_fail: "Failed to load plans, please retry",
    pay_retry: "Retry",
    // Cloud sync
    sync_backup_desc: "Back up your data to the cloud in real time",
    sync_syncing: "Syncing…",
    sync_never: "Never synced",
    sync_fail_toast: "Sync failed, please retry",
    // Login
    login_input_phone: "Please enter your phone number",
    login_input_code: "Please enter the code",
    login_invalid_phone: "Invalid phone number",
    login_code_sent: "Code sent",
    login_send_fail: "Failed to send, please retry",
    login_fail: "Login failed",
    tags: [
      "Focus",
      "Break",
      "Deep Work",
      "Reading",
      "Writing",
      "Learning",
      "Meeting",
      "Sport",
      "Nap",
    ],
  },
  "zh-TW": {
    app_name: "Zeno",
    profile: "個人中心",
    login_title: "歡迎回來",
    login_desc: "登入以同步您的專注數據",
    phone_placeholder: "手機號碼",
    code_placeholder: "驗證碼",
    get_code: "獲取",
    login_btn: "登 入",
    skip_login: "暫不登入",
    member_title: "開通會員",
    unlock_title: "解鎖完整體驗",
    unlock_desc: "投資自己，從每一次專注開始",
    plan_month: "月度會員",
    plan_year: "年度會員",
    plan_lifetime: "終身會員",
    recommend: "推薦",
    save_pct: "立省 30%",
    save_lifetime: "一次付費",
    lifetime_price: "NT$890",
    privilege: "會員權益",
    privileges: [
      { t: "全套高級主題", d: "五行·東方·西學 16 款設計，隨心切換" },
      { t: "高級提示音效", d: "水晶 / 磬音 / 古琴" },
      { t: "數據雲端同步", d: "多設備即時備份" },
    ],
    pay_btn: "立即開通",
    pay_agreement: "支付即代表同意《用戶協議》與《隱私政策》",
    member_active: "您已是 Pro 會員",
    member_active_desc: "已解鎖全部高級權益，盡情專注吧",
    user_guest: "未登入用戶",
    user_login_tip: "點擊登入同步數據",
    user_vip: "Zeno Pro",
    user_title: "專注者",
    user_level: "Level 5 Master",
    stats_title: "學習動態",
    stats_duration: "專注時長",
    stats_streak: "連續打卡",
    stats_tasks: "完成任務",
    banner_title: "Zeno Pro",
    banner_desc: "解鎖全部高級功能與雲端同步",
    banner_desc_vip: "尊享所有高級權益",
    banner_active: "已激活",
    sec_personal: "個性化",
    sec_general: "通用",
    theme_title: "介面主題",
    sound_title: "提示音效",
    lang_title: "語言 / Language",
    haptic_title: "觸感反饋",
    sync_title: "數據同步",
    settings_neuro: "心流設置",
    mode_section: "專注模式",
    mode_hint: "按任務類型選擇節奏，而不是無差別打斷",
    evidence_strong: "證據較強",
    evidence_counter: "建議不打斷",
    interval_label: "隨機間隔 (分鐘)",
    rest_replay_label: "閉眼重放休息",
    rest_none_label: "全程不打斷",
    rest_overlay_title: "閉眼休息",
    rest_overlay_sub: "大腦正在重放剛才的內容…",
    pro_alert_note: "隨機響鈴為 Pro 功能",
    neuro_switch: "心流提示音",
    neuro_desc: "觸發變比率強化，提升專注力",
    neuro_range: "隨機間隔範圍 (分鐘)",
    neuro_tip: "* 提示音響起時，請立即閉眼休息10秒。",
    profile_title: "任務模式",
    profile_memorize: "記憶背誦",
    profile_memorize_d: "3-5分鐘隨機微休息，利用神經重放強化記憶",
    profile_skill: "技能練習",
    profile_skill_d: "4-6分鐘隨機微休息，鞏固動作序列",
    profile_deep: "深度工作",
    profile_deep_d: "4-6分鐘低頻微休息 + 90/20 大循環，可隨時關閉",
    protocol_title: "90/20 循環",
    protocol_desc: "專注結束後自動進入長休息，循環往復",
    protocol_focus_min: "專注(分)",
    protocol_rest_min: "休息(分)",
    protocol_focus_label: "專注",
    protocol_rest_label: "休息中",
    cycle_label: "第",
    cycle_unit: "輪",
    protocol_rest_start: "專注完成！進入長休息",
    protocol_focus_start: "休息結束，開始新一輪專注",
    micro_rest_skip: "點按跳過",
    done_btn: "完成配置",
    close_btn: "關閉",
    start_btn: "開始",
    rest_btn_short: "休息 5 分鐘",
    rest_btn_long: "休息 20 分鐘",
    continue_btn: "繼續",
    congrats_title: "很棒！完成專注",
    session_done_prefix: "已專注",
    session_done_unit: "分鐘",
    session_again: "再來一輪",
    session_rest: "休息 5 分鐘",
    session_share: "分享成績單",
    session_back: "返回",
    week_trend: "心流熱力圖",
    flow_time: "心流時間",
    flow_heatmap_hint: "顏色越深，當日心流時間越長",
    recent_record: "最近記錄",
    today_record: "今日記錄",
    day_record: "當日記錄",
    total_count: "完成",
    count_unit: "項",
    no_record: "該日暫無專注記錄",
    share: "分享",
    share_card_title: "我的專注成績單",
    share_card_slogan: "專注當下，心流不止",
    share_total_focus: "累計專注",
    share_streak: "連續打卡",
    share_sessions: "專注次數",
    share_today_flow: "今日心流",
    share_unit_hours: "小時",
    share_unit_days: "天",
    share_unit_times: "次",
    share_save_img: "儲存圖片",
    share_do_share: "分享",
    share_saved_toast: "圖片已儲存",
    share_close: "關閉",
    share_card_today_title: "今日心流",
    share_card_week_title: "本週累計",
    share_card_total_title: "累計總覽",
    share_week_focus: "本週專注",
    share_today_sessions: "今日完成",
    share_main_tag: "主要專注",
    share_active_days: "活躍天數",
    share_daily_avg: "日均",
    share_weekdays: ["一", "二", "三", "四", "五", "六", "日"],
    sync_toast: "數據同步成功",
    neuro_toast_title: "閉眼休息 10 秒",
    neuro_toast_desc: "大腦正在重放知識...",
    vip_success_title: "歡迎加入 Zeno Pro",
    vip_success_desc: "您已解鎖所有高級權益",
    vip_success_btn: "開始專注之旅",
    sync_last_time: "上次同步",
    sync_cloud_data: "雲端數據",
    sync_auto: "自動同步",
    sync_now: "立即同步",
    sync_records: "條記錄",
    handoff_title: "其他裝置上有專注正在進行",
    handoff_continue: "在此繼續",
    handoff_remaining: "剩餘",
    handoff_adopted: "已接力，繼續專注",
    handoff_surrendered: "已在其他裝置接力",
    handoff_dev_desktop: "桌面端",
    handoff_dev_mobile: "手機端",
    handoff_dev_web: "網頁端",
    // 支付流程
    pay_method_title: "選擇支付方式",
    pay_wechat: "微信支付",
    pay_alipay: "支付寶",
    pay_scan_title: "掃碼支付",
    pay_scan_wechat: "請使用微信掃一掃完成支付",
    pay_scan_alipay: "請使用支付寶掃一掃完成支付",
    pay_failed: "支付失敗",
    pay_unpaid: "訂單未支付",
    pay_processing: "正在處理…",
    pay_loading_plans: "載入方案中…",
    pay_wechat_auth_fail: "無法發起微信授權",
    pay_success_toast: "支付成功",
    pay_load_fail: "方案載入失敗，請重試",
    pay_retry: "重試",
    // 雲端同步
    sync_backup_desc: "即時備份資料至雲端",
    sync_syncing: "同步中…",
    sync_never: "從未同步",
    sync_fail_toast: "同步失敗，請重試",
    // 登入
    login_input_phone: "請輸入手機號",
    login_input_code: "請輸入驗證碼",
    login_invalid_phone: "手機號格式不正確",
    login_code_sent: "驗證碼已發送",
    login_send_fail: "發送失敗，請重試",
    login_fail: "登入失敗",
    tags: [
      "專注",
      "休息",
      "深度工作",
      "閱讀",
      "寫作",
      "學習",
      "會議",
      "運動",
      "小憩",
    ],
  },
};

export const PRESETS = {
  IPHONE: { ar: "390/844", maxW: 390, radius: 48, label: "iPhone" },
  IPAD: { ar: "3/4", maxW: 768, radius: 32, label: "iPad" },
  WATCH: { ar: "4/5", maxW: 320, radius: 56, label: "Watch" },
  WEB: { ar: "16/10", maxW: 1000, radius: 24, label: "Web" },
};

// 提示音元数据。音色由 Web Audio 现场合成（见 utils/sounds.js），键与合成配方一一对应。
export const SOUNDS = {
  chime: {
    name: { "zh-CN": "清铃", en: "Chime", "zh-TW": "清鈴" },
    isPro: false,
  },
  droplet: {
    name: { "zh-CN": "水滴", en: "Droplet", "zh-TW": "水滴" },
    isPro: false,
  },
  marimba: {
    name: { "zh-CN": "木琴", en: "Marimba", "zh-TW": "木琴" },
    isPro: false,
  },
  bell: {
    name: { "zh-CN": "钟声", en: "Bell", "zh-TW": "鐘聲" },
    isPro: false,
  },
  crystal: {
    name: { "zh-CN": "水晶", en: "Crystal", "zh-TW": "水晶" },
    isPro: true,
  },
  gong: {
    name: { "zh-CN": "磬音", en: "Gong", "zh-TW": "磬音" },
    isPro: true,
  },
  koto: {
    name: { "zh-CN": "古琴", en: "Koto", "zh-TW": "古琴" },
    isPro: true,
  },
  ping: {
    name: { "zh-CN": "顿悟", en: "Ping", "zh-TW": "頓悟" },
    isPro: false,
  },
  mute: {
    name: { "zh-CN": "静音", en: "Mute", "zh-TW": "靜音" },
    isPro: false,
  },
};

export const THEMES = [
  {
    id: "metal",
    category: { "zh-CN": "五行", en: "Element", "zh-TW": "五行" },
    name: "金 · 月白",
    meaning: "收敛 / Focus",
    isPro: false,
    isDark: false,
    bg: "#eef2f5",
    cardBg: "linear-gradient(145deg, #ffffff, #dbe4ef)",
    border: "#cbd5e1",
    text: "text-slate-800",
    sub: "text-slate-400",
    toggle: "text-slate-400 hover:text-slate-600 hover:bg-slate-200/50",
    accent:
      "bg-[#64748b] text-white shadow-xl hover:shadow-2xl hover:shadow-slate-500/30",
    tabActive: "bg-[#64748b] text-white",
    particle: ["#94a3b8", "#e2e8f0", "#f1f5f9"],
  },
  {
    id: "wood",
    category: { "zh-CN": "五行", en: "Element", "zh-TW": "五行" },
    name: "木 · 竹青",
    meaning: "生发 / Growth",
    isPro: true,
    isDark: true,
    bg: "#16271f",
    cardBg: "linear-gradient(145deg, #274a3c, #0f1f18)",
    border: "#3c6152",
    text: "text-[#e6f5ef]",
    sub: "text-[#7fd0b0]",
    toggle: "text-[#7fd0b0] hover:text-white hover:bg-white/10",
    accent:
      "bg-[#2f8f66] text-white shadow-xl hover:shadow-2xl hover:shadow-[#2f8f66]/40 border border-[#52b788]/30",
    tabActive: "bg-[#2f8f66] text-white",
    particle: ["#52b788", "#b7e4c7", "#2f8f66"],
  },
  {
    id: "water",
    category: { "zh-CN": "五行", en: "Element", "zh-TW": "五行" },
    name: "水 · 玄冥",
    meaning: "润下 / Wisdom",
    isPro: true,
    isDark: true,
    bg: "#0a141f",
    cardBg: "linear-gradient(145deg, #14273d, #070d16)",
    border: "#203450",
    text: "text-[#e7eefa]",
    sub: "text-[#6f8fb5]",
    toggle: "text-[#6f8fb5] hover:text-white hover:bg-white/10",
    accent:
      "bg-[#235a8c] text-white shadow-xl hover:shadow-2xl hover:shadow-[#235a8c]/40 border border-[#3a6ea5]/30",
    tabActive: "bg-[#235a8c] text-white",
    particle: ["#4a86c5", "#7fb0e0", "#0f2438"],
  },
  {
    id: "fire",
    category: { "zh-CN": "五行", en: "Element", "zh-TW": "五行" },
    name: "火 · 朱砂",
    meaning: "炎上 / Energy",
    isPro: true,
    isDark: true,
    bg: "#280b09",
    cardBg: "linear-gradient(145deg, #6e1c17, #350807)",
    border: "#8a2b22",
    text: "text-[#ffe9df]",
    sub: "text-[#f4a58f]",
    toggle: "text-[#f4a58f] hover:text-white hover:bg-white/10",
    accent:
      "bg-[#c0362b] text-white shadow-xl hover:shadow-2xl hover:shadow-[#c0362b]/40",
    tabActive: "bg-[#c0362b] text-white",
    particle: ["#e5484d", "#c0362b", "#f2856a"],
  },
  {
    id: "earth",
    category: { "zh-CN": "五行", en: "Element", "zh-TW": "五行" },
    name: "土 · 赭石",
    meaning: "稼穑 / Grounded",
    isPro: true,
    isDark: true,
    bg: "#35251a",
    cardBg: "linear-gradient(145deg, #5f4028, #33241a)",
    border: "#7c5636",
    text: "text-[#f5ede0]",
    sub: "text-[#d8c3a2]",
    toggle: "text-[#d8c3a2] hover:text-white hover:bg-white/10",
    accent:
      "bg-[#a06a3c] text-white shadow-xl hover:shadow-2xl hover:shadow-[#a06a3c]/40 border border-[#c19a6b]/30",
    tabActive: "bg-[#a06a3c] text-white",
    particle: ["#c9a274", "#a06a3c", "#5a3f2c"],
  },
  {
    id: "stoic",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "斯多葛 · 磐石",
    meaning: "理性 / Stoic",
    isPro: false,
    isDark: false,
    bg: "#f3f4f6",
    cardBg: "linear-gradient(145deg, #ffffff, #f3f4f6)",
    border: "#d1d5db",
    text: "text-gray-900",
    sub: "text-gray-400",
    toggle: "text-gray-400 hover:text-gray-600 hover:bg-gray-100",
    accent:
      "bg-gray-800 text-white shadow-xl hover:shadow-2xl hover:shadow-gray-800/20",
    tabActive: "bg-gray-800 text-white",
    particle: ["#9ca3af", "#6b7280", "#4b5563"],
  },
  {
    id: "cyber",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "赛博 · 幻夜",
    meaning: "霓虹 / Cyber",
    isPro: true,
    isDark: true,
    bg: "#09090b",
    cardBg: "linear-gradient(145deg, #18181b, #09090b)",
    border: "#22c55e",
    text: "text-pink-500",
    sub: "text-green-500/70",
    toggle: "text-zinc-600 hover:text-pink-400 hover:bg-white/5",
    accent:
      "bg-pink-600 text-white shadow-xl hover:shadow-2xl hover:shadow-pink-600/40 border border-green-500/30",
    tabActive: "bg-pink-600 text-white",
    particle: ["#ec4899", "#22c55e", "#a855f7"],
  },
  {
    id: "industrial",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "蒸汽 · 齿轮",
    meaning: "秩序 / Steam",
    isPro: true,
    isDark: true,
    bg: "#1c1917",
    cardBg: "linear-gradient(145deg, #292524, #1c1917)",
    border: "#d97706",
    text: "text-amber-50",
    sub: "text-amber-500/50",
    toggle: "text-stone-500 hover:text-amber-400 hover:bg-white/5",
    accent:
      "bg-amber-700 text-white shadow-xl hover:shadow-2xl hover:shadow-amber-700/40",
    tabActive: "bg-amber-700 text-white",
    particle: ["#d97706", "#b45309", "#78350f"],
  },
  {
    id: "impression",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "印象派 · 晨雾",
    meaning: "光影 / Light",
    isPro: true,
    isDark: false,
    bg: "#fff7ed",
    cardBg: "linear-gradient(145deg, #fff1f2, #fef3c7)",
    border: "#fcd34d",
    text: "text-indigo-900",
    sub: "text-indigo-400",
    toggle: "text-orange-300 hover:text-indigo-500 hover:bg-white/50",
    accent:
      "bg-indigo-400 text-white shadow-xl hover:shadow-2xl hover:shadow-indigo-400/20",
    tabActive: "bg-indigo-400 text-white",
    particle: ["#818cf8", "#fcd34d", "#fca5a5"],
  },
  {
    id: "interstellar",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "深空 · 星轨",
    meaning: "引力 / Interstellar",
    isPro: true,
    isDark: true,
    bg: "#020617",
    cardBg: "linear-gradient(145deg, #172554, #000000)",
    border: "#1e3a8a",
    text: "text-blue-50",
    sub: "text-blue-300/40",
    toggle: "text-blue-800 hover:text-blue-200 hover:bg-white/10",
    accent:
      "bg-blue-700 text-white shadow-xl hover:shadow-2xl hover:shadow-blue-700/40",
    tabActive: "bg-blue-700 text-white",
    particle: ["#3b82f6", "#60a5fa", "#ffffff"],
  },
  // ===== 2026-07 新增批次：Claude 风格 + 东方 / 西方各一组 =====
  {
    // Claude 风格：Anthropic 象牙纸底 + 陶土橘强调，免费开放作为招牌主题
    id: "claude",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "Claude · 陶土",
    meaning: "灵感 / Claude",
    isPro: false,
    isDark: false,
    bg: "#f0eee6",
    cardBg: "linear-gradient(145deg, #faf9f5, #e6e2d6)",
    border: "#dcd7c9",
    text: "text-stone-800",
    sub: "text-stone-400",
    toggle: "text-stone-400 hover:text-stone-600 hover:bg-stone-200/60",
    accent:
      "bg-[#c96442] text-white shadow-xl hover:shadow-2xl hover:shadow-[#c96442]/40",
    tabActive: "bg-[#c96442] text-white",
    particle: ["#c96442", "#e8b294", "#f0eee6"],
  },
  {
    // 敦煌壁画：赭沙暗底 + 鎏金强调
    id: "dunhuang",
    category: { "zh-CN": "东方", en: "East", "zh-TW": "東方" },
    name: "敦煌 · 鸣沙",
    meaning: "丝路 / Dunhuang",
    isPro: true,
    isDark: true,
    bg: "#2b1c10",
    cardBg: "linear-gradient(145deg, #4a3018, #2b1a0c)",
    border: "#6b4a26",
    text: "text-[#f5e7c8]",
    sub: "text-[#c9a86a]",
    toggle: "text-[#c9a86a] hover:text-white hover:bg-white/10",
    accent:
      "bg-[#b8860b] text-white shadow-xl hover:shadow-2xl hover:shadow-[#b8860b]/40",
    tabActive: "bg-[#b8860b] text-white",
    particle: ["#d4a017", "#8b5a2b", "#3e6b5e"],
  },
  {
    // 水墨留白：宣纸浅底 + 墨色强调
    id: "ink",
    category: { "zh-CN": "东方", en: "East", "zh-TW": "東方" },
    name: "水墨 · 留白",
    meaning: "空灵 / Ink",
    isPro: true,
    isDark: false,
    bg: "#f6f6f1",
    cardBg: "linear-gradient(145deg, #ffffff, #e9e9e1)",
    border: "#d6d6cc",
    text: "text-neutral-800",
    sub: "text-neutral-400",
    toggle: "text-neutral-400 hover:text-neutral-700 hover:bg-neutral-200/50",
    accent:
      "bg-[#303030] text-white shadow-xl hover:shadow-2xl hover:shadow-neutral-800/30",
    tabActive: "bg-[#303030] text-white",
    particle: ["#303030", "#9c9c94", "#e9e9e1"],
  },
  {
    // 青花瓷：月白泛蓝底 + 钴蓝强调
    id: "porcelain",
    category: { "zh-CN": "东方", en: "East", "zh-TW": "東方" },
    name: "青花 · 瓷韵",
    meaning: "素雅 / Porcelain",
    isPro: true,
    isDark: false,
    bg: "#f2f6fa",
    cardBg: "linear-gradient(145deg, #ffffff, #dfe9f3)",
    border: "#c3d4e6",
    text: "text-[#1d3557]",
    sub: "text-[#7b9ac2]",
    toggle: "text-[#7b9ac2] hover:text-[#1e50a2] hover:bg-blue-100/50",
    accent:
      "bg-[#1e50a2] text-white shadow-xl hover:shadow-2xl hover:shadow-[#1e50a2]/40",
    tabActive: "bg-[#1e50a2] text-white",
    particle: ["#1e50a2", "#7b9ac2", "#ffffff"],
  },
  {
    // 北欧极夜：Nord 蓝灰暗底 + 冰川蓝强调
    id: "nord",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "北欧 · 极夜",
    meaning: "静谧 / Nord",
    isPro: true,
    isDark: true,
    bg: "#2e3440",
    cardBg: "linear-gradient(145deg, #3b4252, #2e3440)",
    border: "#4c566a",
    text: "text-[#eceff4]",
    sub: "text-[#81a1c1]",
    toggle: "text-[#81a1c1] hover:text-white hover:bg-white/10",
    accent:
      "bg-[#5e81ac] text-white shadow-xl hover:shadow-2xl hover:shadow-[#5e81ac]/40",
    tabActive: "bg-[#5e81ac] text-white",
    particle: ["#88c0d0", "#81a1c1", "#eceff4"],
  },
  {
    // 暗色学院风：书斋深棕底 + 黄铜强调（dark academia）
    id: "academia",
    category: { "zh-CN": "西学", en: "West", "zh-TW": "西學" },
    name: "学院 · 沉潜",
    meaning: "书斋 / Academia",
    isPro: true,
    isDark: true,
    bg: "#211a12",
    cardBg: "linear-gradient(145deg, #372c1e, #211a12)",
    border: "#59452c",
    text: "text-[#efe6d5]",
    sub: "text-[#b39b6e]",
    toggle: "text-[#b39b6e] hover:text-white hover:bg-white/10",
    accent:
      "bg-[#8c6b2f] text-white shadow-xl hover:shadow-2xl hover:shadow-[#8c6b2f]/40",
    tabActive: "bg-[#8c6b2f] text-white",
    particle: ["#b39b6e", "#8c6b2f", "#3a2f1e"],
  },
];

// 主题选择器「精选」清单：东方五行 5 款 + 西方精选 5 款 + Claude，
// 默认平铺展示；其余主题收进「更多」折叠区。改这里即可调整主区内容，不动主题定义。
export const FEATURED_THEME_IDS = [
  // 东方 · 五行
  "metal",
  "wood",
  "water",
  "fire",
  "earth",
  // 西方 · 精选
  "stoic",
  "impression",
  "interstellar",
  "nord",
  "academia",
  // 特别款
  "claude",
];

// 专注模式（任务模式 Profile）—— 让心流提示音"懂任务"，而不是无差别打断。
// 每种模式的配置都对应一条科学依据（evidence: strong=证据较强 / counter=反而建议不打断）。
export const FOCUS_MODES = [
  {
    id: "memorize",
    icon: "Brain",
    color: "#10b981", // emerald
    name: { "zh-CN": "记忆 · 背诵", en: "Memorize", "zh-TW": "記憶 · 背誦" },
    tagline: {
      "zh-CN": "背书 / 单词 / 公式",
      en: "Rote / facts",
      "zh-TW": "背書 / 單詞 / 公式",
    },
    randomAlert: true,
    intervalMin: 3,
    intervalMax: 5,
    restType: "replay",
    restSeconds: 10,
    evidence: "strong",
    rationale: {
      "zh-CN":
        "神经重放证据在记忆/序列学习上最强。每 3–5 分钟闭眼 10 秒，让大脑高速“回放”刚记的内容，巩固效果最好。",
      en: "Replay evidence is strongest for rote/sequence learning. A 10s eyes-closed rest every 3–5 min lets the brain replay what you just encoded.",
      "zh-TW":
        "神經重放證據在記憶/序列學習上最強。每 3–5 分鐘閉眼 10 秒，讓大腦高速「回放」剛記的內容。",
    },
  },
  {
    id: "skill",
    icon: "Activity",
    color: "#3b82f6", // blue
    name: { "zh-CN": "技能 · 练习", en: "Practice", "zh-TW": "技能 · 練習" },
    tagline: {
      "zh-CN": "乐器 / 编程 / 运动",
      en: "Skill drills",
      "zh-TW": "樂器 / 編程 / 運動",
    },
    randomAlert: true,
    intervalMin: 4,
    intervalMax: 6,
    restType: "replay",
    restSeconds: 10,
    evidence: "strong",
    rationale: {
      "zh-CN":
        "重放实验本就基于运动技能。休息穿插在练习回合之间最有效，所以间隔略长（4–6 分钟），尽量落在自然练习块边界。",
      en: "Replay research is based on motor skills. Rests work best between practice bouts, so the interval is longer (4–6 min) to land near natural chunk boundaries.",
      "zh-TW":
        "重放實驗本就基於運動技能。休息穿插在練習回合之間最有效，間隔略長（4–6 分鐘）。",
    },
  },
  {
    id: "deepwork",
    icon: "Zap",
    color: "#f59e0b", // amber
    name: { "zh-CN": "深度 · 工作", en: "Deep Work", "zh-TW": "深度 · 工作" },
    tagline: {
      "zh-CN": "写作 / 推理 / 解题",
      en: "Hard thinking",
      "zh-TW": "寫作 / 推理 / 解題",
    },
    randomAlert: true,
    intervalMin: 4,
    intervalMax: 6,
    restType: "replay",
    restSeconds: 10,
    evidence: "counter",
    rationale: {
      "zh-CN":
        "深度推理需长时间占用工作记忆，频繁打断会产生“注意力残留”。因此这里默认用更长的 4–6 分钟低频提示音并叠加 90/20 大循环；若你需要全程不被打断的沉浸，可随时一键关闭。",
      en: "Deep reasoning holds working memory for long stretches, and frequent interruptions cause attention residue. So alerts default to a longer 4-6 min low-frequency interval on top of the 90/20 cycle - turn them off anytime for fully uninterrupted immersion.",
      "zh-TW":
        "深度推理需長時間佔用工作記憶，頻繁打斷會產生「注意力殘留」。因此這裡預設用更長的 4–6 分鐘低頻提示音並疊加 90/20 大循環；若需全程沉浸，可隨時一鍵關閉。",
    },
  },
];

export const TAG_MAP = {
  // zh-CN
  专注: 25 * 60,
  休息: 10 * 60,
  深度工作: 90 * 60,
  阅读: 30 * 60,
  写作: 30 * 60,
  学习: 45 * 60,
  会议: 30 * 60,
  运动: 30 * 60,
  小憩: 15 * 60,
  // en
  Focus: 25 * 60,
  Break: 10 * 60,
  "Deep Work": 90 * 60,
  Reading: 30 * 60,
  Writing: 30 * 60,
  Learning: 45 * 60,
  Meeting: 30 * 60,
  Sport: 30 * 60,
  Nap: 15 * 60,
  // zh-TW（与简体同形的字不重复列出）
  專注: 25 * 60,
  閱讀: 30 * 60,
  寫作: 30 * 60,
  學習: 45 * 60,
  會議: 30 * 60,
  運動: 30 * 60,
};

// 休息类标签（完成后不计入专注统计），覆盖三种语言
export const REST_TAGS = ["休息", "小憩", "Break", "Nap"];

// 任务模式：三种模式的心流提示音均默认开启（产品决策 2026-07）。
// 深度工作用更长的 4–6 分钟低频间隔减少打断，并叠加 90/20 大循环；
// 追求全程沉浸的用户可在设置里随时一键关闭。
export const PROFILES = {
  memorize: { random: true, min: 3, max: 5, protocol: false },
  skill: { random: true, min: 4, max: 6, protocol: false },
  deep: { random: true, min: 4, max: 6, protocol: true },
};
